import "./style.css";
import * as THREE from "three";
import gsap from "gsap";

import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as dat from "dat.gui";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader.js";
import { MTLLoader } from "three/examples/jsm/loaders/MTLLoader.js";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
/**
 * Debug
 */


// const gui = new dat.GUI();


const canvas = document.querySelector(".webgl");

////////////////////////////////////////////////////////////////////////////
// END OF DEBUG
////////////////////////////////////////////////////////////////////////////
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true,
  antialias: true,
});
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
/**
 * creating scene
 */
const scene = new THREE.Scene();

////////////////////////////////////////////////////////////////////////////
// END OF SCENE
////////////////////////////////////////////////////////////////////////////

/**
 * Geometry
 */
const geometry = new THREE.BoxBufferGeometry(1, 1, 1);
const material = new THREE.MeshBasicMaterial({
  color: "white",
});

////////////////////////////////////////////////////////////////////////////
// END OF GEOMETRY
////////////////////////////////////////////////////////////////////////////

/**
 * Mesh
 */

// const mesh = new THREE.Mesh(geometry, material);
// scene.add(mesh);

////////////////////////////////////////////////////////////////////////////
// END OF MESH
////////////////////////////////////////////////////////////////////////////

// todo size
const size = {
  width: window.innerWidth,
  height: window.innerHeight,
};

////////////////////////////////////////////////////////////////////////////
// END OF SIZE
////////////////////////////////////////////////////////////////////////////

/**
 * camera
 */

const camera = new THREE.PerspectiveCamera(75, size.width / size.height);
camera.position.z = 115;
camera.position.y = 68.9;
camera.position.x = 21.6;

// gui.add(camera.position, "x", -80, 80, 0.1).name("camera p X");
// gui.add(camera.position, "y", -200, 80, 0.1).name("camera p y");
// gui.add(camera.position, "z", -80, 400, 0.1).name("camera p z");

window.addEventListener("resize", () => {
  // resize canvas

  size.width = window.innerWidth;
  size.height = window.innerHeight;
  //   update camera
  camera.aspect = size.width / size.height;
  camera.updateProjectionMatrix();
  renderer.setSize(size.width, size.height);
});

////////////////////////////////////////////////////////////////////////////
// END OF CAMERA
////////////////////////////////////////////////////////////////////////////

/**
 * Renderer
 */

const distanceLight = new THREE.DirectionalLight(0xffffff, 2);
scene.add(distanceLight);

// Set the direction of the light
distanceLight.position.set(10, 0, 350);

// Allow shadow casting
distanceLight.castShadow = true;
const ambinentLight = new THREE.AmbientLight(0xffffff, 2);

ambinentLight.position.x = 2;
scene.add(ambinentLight);

const fbxLoader = new FBXLoader();
fbxLoader.load("./earth/Cartoon Plane.fbx", (plane) => {
  plane.scale.x = 0.5 / 44;
  plane.scale.y = 0.5 / 44;
  plane.scale.z = 0.5 / 44;

  plane.position.z = 4;
  plane.position.y = 65.89;
  plane.rotation.x = 0.06503;
  plane.rotation.y = 7.65208;
  plane.castShadow = true;
//   gui.add(plane.position, "x", -80, 80, 0.01).name("Plane p X");
//   gui.add(plane.position, "y", -200, 80, 0.01).name("Plane p y");
//   gui.add(plane.rotation, "x", 0, 10, 0.00001).name("Plane r X");
//   gui.add(plane.rotation, "y", 0, 10, 0.00001).name("Plane r  Y");

//   const mouse = {
//     y: 65.89,
//   };
//   window.addEventListener("mousemove", (event) => {
//     mouse.x =event.offsetX /   0.06503;
//     mouse.y = event.offsetY /1000;
  
//     console.log(mouse.y,mouse.x);
//   });
  // animatingplane
  const clock = new THREE.Clock();
  const animatePlane = () => {
    const elapsedTime = clock.getElapsedTime();
    plane.rotation.x = Math.sin(elapsedTime) / 6;
    plane.position.x = Math.sin(elapsedTime) * 3;

    // plane.position.y = (mouse.y );
    // plane.position.x = (mouse.x);

    plane.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
      }
    });
    window.requestAnimationFrame(animatePlane);
  };
  animatePlane();

  scene.add(plane);
});
fbxLoader.load("./earth/low_poly_earth.fbx", (earth) => {
  earth.position.y = -104.1;
  earth.rotation.x = 20;
  earth.scale.x = 1.6;
  earth.scale.y = 1.6;
  earth.scale.z = 1.6;
//   gui.add(earth.position, "x", -80, 80, 0.1).name("earth p X");
//   gui.add(earth.position, "y", -200, 80, 0.1).name("earth p y");
//   gui.add(earth.rotation, "x", -80, 80, 0.1).name("earth r X");
//   gui.add(earth.rotation, "y", -80, 80, 0.1).name("earth r y");

  earth.traverse((child) => {
    if (child instanceof THREE.Mesh) {
      child.receiveShadow = true;
    }
  });
  scene.add(earth);

  const clock = new THREE.Clock();
  let animation = () => {
    const elapsedTime = clock.getElapsedTime();
    earth.rotation.y = (elapsedTime / Math.PI) * 2;
    window.requestAnimationFrame(animation);
  };
  animation();
});

// mtlLoader.load("./earth/low_poly_earth.mtl", (material) => {
//   material.preload();
//   const loader = new OBJLoader();
//   loader.setMaterials(material);
//   loader.load("./earth/low_poly_earth.obj", (earth) => {
//     earth.traverse(function(child) {

//     })
//     scene.add(earth);
//   });
// });

scene.add(camera);

////////////////////////////////////////////////////////////////////////////
// END OF RENDERER
////////////////////////////////////////////////////////////////////////////

// controlss
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
renderer.setSize(size.width, size.height);
renderer.render(scene, camera);

////////////////////////////////////////////////////////////////////////////
// END OF CONTROLS
////////////////////////////////////////////////////////////////////////////

/**
 * Animation
 */

const clock = new THREE.Clock();

const animate = () => {
  const elapsedTime = clock.getElapsedTime();

  controls.update();
  // mesh.rotation.x= elapsedTime;
  renderer.render(scene, camera);
  window.requestAnimationFrame(animate);
};

animate();

////////////////////////////////////////////////////////////////////////////
// END OF ANIMATION
////////////////////////////////////////////////////////////////////////////


let headOne= document.querySelector('.headOne')

text(headOne);

function text(elem) {
    let elementWidth = elem.offsetWidth;
    let windowWidth=  window.innerWidth;

    let flag=0;

    setInterval(() => {
        elem.style.marginLeft = --flag + "px";
  
        if (elementWidth == -flag) {
            flag = windowWidth;
        }
    }, 10);
}


